import React from "react";
import { Card, CardContent, Typography, Button, Chip } from "@mui/material";

const HeroSection = () => (
  <Card
    variant="outlined"
    sx={{
      textAlign: "center",
      p: { xs: 2, sm: 4, md: 6 },
      mb: 6,
      backgroundColor: "#ffffff",
      borderColor: "rgba(0, 0, 0, 0.12)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    }}
  >
    <CardContent>
      <Chip
        label="Professional Social Media Services"
        color="primary"
        sx={{ mb: 2 }}
      />
      <Typography
        variant="h3"
        component="h1"
        gutterBottom
        sx={{
          fontWeight: "bold",
          mt: 2,
          color: "text.primary",
          fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
        }}
      >
        Grow Your Business with Expert Social Media Management
      </Typography>
      <Typography
        variant="h6"
        sx={{
          mb: 4,
          color: "text.secondary",
          fontSize: { xs: "1rem", sm: "1.25rem" },
          lineHeight: 1.6,
        }}
      >
        We help businesses establish a strong online presence through strategic
        social media management and SEO optimization.
      </Typography>
      <Button
        variant="contained"
        size="large"
        sx={{
          px: 4,
          py: 1.5,
          fontSize: "1.1rem",
          borderRadius: 2,
        }}
      >
        Get Started Today
      </Button>
    </CardContent>
  </Card>
);

export default HeroSection;
